/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { IconQueryData } from "../../core/models/Icon";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useIconsContext } from "./IconsContext";

const useIconsActions = () => {
  const {
    setIconsResponseData,
    setIconsLoading,
    setSelectedIcon,
    setIconsError,
  } = useIconsContext();

  const dispatchGetIcons = async (
    query: IconQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getIcons();
      setIconsResponseData(data);
      setIconsError(undefined);
      return data;
    } catch (e: any) {
      setIconsError(e);
    } finally {
      setIconsLoading(false);
    }
  };

  const dispatchCleanIconsContext = () => {
    setIconsResponseData(undefined);
    setIconsError(undefined);
    setSelectedIcon(undefined);
  };

  return {
    dispatchGetIcons,
    setSelectedIcon,
    dispatchCleanIconsContext,
  };
};

export { useIconsActions };
